const EChannelState = {
  Created: "CREATE",
  Deleted: "DELETE",
  Hidden: "HIDDEN",
} as const;

type EChannelState = typeof EChannelState[keyof typeof EChannelState];

export { EChannelState };
